// removed by extract-text-webpack-plugin
module.exports = {"panel":"panel--panel--1Mj368zP"};


//////////////////
// WEBPACK FOOTER
// ./src/baseComponents/components/Panel/panel.scss
// module id = 620
// module chunks = 0